module.exports = __webpack_public_path__ + "static/GitHub-white-56a07f4aac8ea5d6b18f58c5566d84c5.png";